import React, { useMemo } from 'react';
import DefaultLink from './email-link';
import OfficeButtonLink from './office-button-link';
import { observer } from 'mobx-react';

function EmailLinkFactory({ link, ...rest }) {
    const Component = useMemo(() => {
        switch (link.variant) {
            case 'office':
                return OfficeButtonLink; // The blue gradient button used by Microsoft Office 365
            default:
                return DefaultLink;
        }
    }, [link]);

    return <Component link={link} {...rest} />;
}

export default observer(EmailLinkFactory);
